export const elevesUrls = {
  all: 'eleves',
  views: () => `${elevesUrls.all}/views`,
  viewDetails: (id: string) => `${elevesUrls.views()}/${id}`,
  eleveDetails: (id: string, viewId?: string) => {
    if (viewId) {
      return `${elevesUrls.all}/${id}/general?viewId=${viewId}`;
    }
    return `${elevesUrls.all}/${id}/general`;
  },
  eleveDetailsPresentisme: (id: string) => `${elevesUrls.all}/${id}/presences`,
};
